import { render, staticRenderFns } from "./xl.vue?vue&type=template&id=d49c2274&scoped=true&"
import script from "./xl.vue?vue&type=script&lang=js&"
export * from "./xl.vue?vue&type=script&lang=js&"
import style0 from "./xl.vue?vue&type=style&index=0&id=d49c2274&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d49c2274",
  null
  
)

export default component.exports